import { Component } from '@angular/core';

@Component({
  selector: 'app-help',
  templateUrl: './gcv-help.component.html',
})
export class GcvHelpComponent {
  constructor() {}
}
